// @core/api/endpoints/chat/list_mention_tags.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListMentionTagsResponse,
} from '../../../types/chat';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/chat';

/**
 * List mention tags
 * Returns all custom mention tags available in the conversation.
 */
export async function ListMentionTags(
  conversation_id: string,
  params?: PaginatedRequest,
  options?: RequestOptions
): Promise<ListMentionTagsResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/conversations/:conversation_id/mention-tags`;
  requestPath = requestPath.replace(':conversation_id', encodeURIComponent(conversation_id));
  const requestOptions = options;
  return client.get<ListMentionTagsResponse>(requestPath, { ...requestOptions, params });
}
